module.exports = __webpack_public_path__ + "media/images/lb/701-719e6bf901319dbe61a2fc0803e6360d.svg";